import React from 'react';
import './BrowserWindow.css';

/**
 * Simulated browser window that replaces the reading pane (advisor §3.5): tab strip,
 * address bar with a Back-to-inbox control, content area filling the rest of the pane.
 * Identical chrome in all four arms; only the content differs.
 */
export interface BrowserWindowProps {
  url: string;
  title: string;
  /** Lock for https on a university host, ⓘ otherwise. */
  secure: boolean;
  onBack?: () => void;
  backLabel?: string;
  backTestId?: string;
  children: React.ReactNode;
  variant?: 'browser' | 'phone' | 'call' | 'text';
}

const BrowserWindow: React.FC<BrowserWindowProps> = ({ url, title, secure, onBack, backLabel = '← Back to inbox', backTestId = 'back-to-inbox', children, variant = 'browser' }) => (
  <div className={`browser-window bw-${variant}`} data-testid="browser-window">
    {variant === 'browser' && (
      <>
        <div className="bw-tabs">
          <span className="bw-tab"><span className={`bw-favicon${secure ? ' ok' : ''}`} aria-hidden="true" />{title}</span>
        </div>
        <div className="bw-addr-row">
          {onBack && <button type="button" className="bw-back" data-testid={backTestId} onClick={onBack}>{backLabel}</button>}
          <div className="main-dest-bar">
            <span className="main-dest-lock" title={secure ? 'Secure connection' : 'Connection information'}>{secure ? '🔒' : 'ⓘ'}</span>
            <span className="main-dest-url">{url}</span>
          </div>
        </div>
      </>
    )}
    <div className="bw-content">{children}</div>
  </div>
);

export default BrowserWindow;
